import { useContext } from 'react';
import ExperimentsContext from '../state/ExperimentsContext';

/**
 * Returns an array of ab test variants. Used for analytics
 */
const useAllAbVariants = (): string[] => {
  const flags = useContext(ExperimentsContext);
  return flags?.abVariants ?? [];
};

export default useAllAbVariants;
